module.exports = __webpack_public_path__ + "images/emoji/bowtie.73de09ce6675cadd5975.png";